import { Link, useStaticQuery, graphql } from "gatsby"
import React, { useState } from "react"
import { animated } from "react-spring"
import styled from "styled-components"

import { device } from "../utils/device"
import Button from "./Button"

const Container = styled.div`
  display: flex;
  align-items: center;
  height: 80px;

  > a {
    margin: 0 25px;
  }

  @media only screen and (min-width: 1025px) and (max-width: 1199px) {
    > a {
      margin: 0;
    }
  }

  @media (max-width: 1200px) {
    > a {
      margin: 0 15px;
    }
  }

  @media ${device.tablet} {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: calc(100vh - 200px);
    > a {
      margin: 0;
    }

    .signup-btn {
      margin-top: 20px;
    }
  }

  @media (max-width: 991px) {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: calc(100vh - 200px);
  }
`

const NavItem = styled(Link)`
  height: 100%;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${props =>
    props.dark ? props.theme.colors.white : props.theme.colors.black};
  font-family: "Nunito Sans", sans-serif;
  white-space: nowrap;
  font-weight: bold;
  letter-spacing: 0.02em;
  transition: all 200ms ease-in;

  ${props => (props.collapse === "true" ? `display: none;` : ``)};

  @media ${device.tablet} {
    display: flex;
    height: 50px;

    ${props => (props.subnav === "true" ? `display: none;` : ``)};
  }

  @media (max-width: 991px) {
    display: flex;

    ${props => (props.subnav === "true" ? `display: none;` : ``)};
  }

  span {
    position: relative;

    &:after {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 0%;
      content: ".";
      color: transparent;
      background: ${props =>
        props.dark ? props.theme.colors.darkOrange : props.theme.colors.black};
      height: 1px;
      transition: all 0.2s ease-in-out;
    }

    ${props =>
      props.hover === "true"
        ? `color: ${
            props.dark
              ? props.theme.colors.darkOrange
              : props.theme.colors.black
          };
        &::after {
        width: 100%;
      }`
        : ``}

    &:hover {
      color: ${props =>
        props.dark ? props.theme.colors.darkOrange : props.theme.colors.black};

      &::after {
        width: 100%;
      }
    }
  }

  @media ${device.tablet} {
    padding: 10px 0;
    margin: 10px 0;
    font-size: 1.3rem;
    z-index: 6;
    margin-left: 0px;
  }
`

const ExternalNavItem = styled.a`
  height: 100%;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${props => props.dark ? props.theme.colors.white : props.theme.colors.black};
  font-family: "Nunito Sans", sans-serif;
  white-space: nowrap;
  font-weight: bold;
  letter-spacing: 0.02em;
  transition: all 200ms ease-in;

  ${props => (props.collapse === "true" ? `display: none;` : ``)};

  @media ${device.tablet} {
    display: flex;
    height: 50px;
    ${props => (props.subnav === "true" ? `display: none;` : ``)};
  }

  @media (max-width: 991px) {
    display: flex;
    ${props => (props.subnav === "true" ? `display: none;` : ``)};
  }

  span {
    position: relative;

    &:after {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 0%;
      content: ".";
      color: transparent;
      background: ${props => props.dark ? props.theme.colors.darkOrange : props.theme.colors.black};
      height: 1px;
      transition: all 0.2s ease-in-out;
    }

    ${props =>
      props.hover === "true"
        ? `color: ${
            props.dark
              ? props.theme.colors.darkOrange
              : props.theme.colors.black
          };
        &::after {
        width: 100%;
      }`
        : ``}

    &:hover {
      color: ${props =>
        props.dark ? props.theme.colors.darkOrange : props.theme.colors.black};
      &::after {
        width: 100%;
      }
    }
  }

  @media ${device.tablet} {
    padding: 10px 0;
    margin: 10px 0;
    font-size: 1.3rem;
    z-index: 6;
  }
`

const Div = styled(animated.div)`
  display: flex;
  box-shadow: rgba(37, 36, 65, 0.2) 0px 10px 20px 0px;
  position: absolute;
  width: min-content;
  top: 210px;
  left: 32%;
  background-color: ${props => props.theme.colors.white};
  border-radius: 5px;
  transform: translate(-50%, -50%);
  align-items: baseline;

  @media ${device.tablet} {
    display: none;
    width: 100%;
  }

  @media (max-width:5000px){
    left:auto;
  }

  @media (max-width:2560px){
    left:32%;
  }

  @media (max-width: 1450px) {
    left: 32%;
  }
  @media (max-width: 1200px) {
    left: 27%;
  }

  @media only screen and (min-width: 992px) and (max-width: 1024px) {
    left: 27%;
  }

  @media only screen and (min-width: 1025px) and (max-width: 1199px) {
    left: 27%;
  }

  h4 {
    color: ${props => props.theme.colors.gray};
  }

  p {
    font-size: 14px;
    color: ${props => props.theme.colors.darkGray};
    width: 200px;
    text-align: center;
    padding: 0 5px;
  }
`

const TestDiv = styled(animated.div)`
  display: flex;
  flex-direction: column;
  box-shadow: rgba(37, 36, 65, 0.2) 0px 10px 20px 0px;
  position: absolute;
  width: 250px;
  top: 100%;
  
  @media only screen and (min-width: 992px) and (max-width: 1199px) {
    margin:0 65px;
  }

  @media only screen and (min-width: 1200px) and (max-width: 5000px) {
    margin:0 65px;
  }

  overflow: hidden;
  background-color: ${props => props.theme.colors.white};
  border-radius: 10px;

  @media ${device.tablet} {
    display: none;
    width: 100%;
  }

  a {
    font-size: 16px;
    margin: 0;
    padding: 12px 24px;
    color: ${props => props.theme.colors.darkGray};
    text-decoration: none;
  }
  a:hover,
  a:active {
    background-color: #f8f8f8;
    color: ${props => props.theme.colors.mediumOrange};
  }
`

const LeftContainer = styled.div`
  display: block;

  width: 100%;
  border-radius: 0;
  border-right: 2px solid #f3f3f3;
  color: ${props => props.theme.colors.text.darkGray};

  padding: 30px 20px;
  height: 260px;

  a, a:hover, a:focus, a:active {
    text-decoration: none;
    color: inherit;
}

  h4 {
    margin-bottom: 15px;
    text-align: center;
    font-family: "Work Sans", sans-serif;
  }

  &:hover {
    background: #ecf1f4;
    cursor: pointer;
    color: #004385;
    border-radius: 5px;
  }

  :last-child {
    border: none;
  }

  @media (max-width: 1440px) {
    p {
      width: 195px;
    }
  }

  @media only screen and (min-width: 992px) and (max-width: 1024px) {
    padding: 30px 0px;
    p {
      padding-right: 5px;
      padding-left: 5px;
      width: 195px;
    }
    div {
      height: 70px;
      width: 70px;
    }
  }

  @media only screen and (min-width: 1025px) and (max-width: 1199px) {
    padding: 30px 0px;
  }
`

const Image = styled.div`
  background-image: url(${props => props.image});
  background-size: contain;
  background-repeat: no-repeat;
  width: 80px;
  height: 80px;
  margin-bottom: 15px !important;
  margin: 0 auto;
`

const NavbarLinks = props => {
  const data = useStaticQuery(graphql`
    query navbar {
      strapiNavbar {
        ProductsText
        TestsText
        TestsLink
        Tests {
          Name
          Slug
        }
        OtherLinks {
          Text
          Reference
        }
        LoginText
        LoginLink
        SignupText
        SignupLink
        Products {
          Name
          Description {
            data {
              Description
            }
          }
          MoreInfoUrl
          Icon {
            localFile {
              publicURL
            }
            width
            height
          }
        }
      }
    }
  `)
  const navbar = data.strapiNavbar

  const [hover, setHover] = useState(false)
  const [hoverTests, setHoverTests] = useState(false)

  const openBigMenu = () => {
    setHover(true)
  }

  const closeBigMenu = () => {
    setHover(false)
  }

  const openPracticeTests = () => {
    setHoverTests(true)
  }

  const closePracticeTests = () => {
    setHoverTests(false)
  }

  const localLinkRegEx = new RegExp(/^\//)
  const isLocalLink = (link) => {
    return localLinkRegEx.test(link.Reference);
  }

  return (
    <Container>
      <NavItem
        {...props}
        subnav="true"
        to="#"
        onMouseEnter={openBigMenu}
        onMouseLeave={closeBigMenu}
        hover={hover ? "true" : "false"}
      >
        <span>{navbar.ProductsText}</span>
      </NavItem>
      {navbar.Products?.map((p, index) => {
        return (
          <NavItem {...props} collapse="true" to={p.MoreInfoUrl} key={index}>
            <span>{p.Name}</span>
          </NavItem>
        )
      })}
      <NavItem
        {...props}
        subnav="true"
        to={navbar.TestsLink}
        onMouseEnter={openPracticeTests}
        onMouseLeave={closePracticeTests}
        hover={hoverTests ? "true" : "false"}
      >
        <span>{navbar.TestsText}</span>
      </NavItem>
      {navbar.OtherLinks.map((link, index) => {
        return isLocalLink(link) ?
          <NavItem {...props} to={link.Reference} key={index}>
            <span>{link.Text}</span>
          </NavItem>
          :
          <ExternalNavItem {...props} href={link.Reference} key={index}>
            <span>{link.Text}</span>
          </ExternalNavItem>
      })}

      <ExternalNavItem {...props} href={process.env.GATSBY_API_URL + navbar.LoginLink}>
        <span>{navbar.LoginText}</span>
      </ExternalNavItem>

      <Link to={navbar.SignupLink}>
        <Button.Small style={{minWidth: '150px'}} className="signup-btn">
          {navbar.SignupText}
        </Button.Small>
      </Link>
      {hover && (
        <Div onMouseEnter={openBigMenu} onMouseLeave={closeBigMenu}>
          {navbar.Products?.map((product, index) => {
            return (
              <LeftContainer key={index}>
                  <Link to={product.MoreInfoUrl}>
                  <Image image={product.Icon.localFile.publicURL} />
                  <h4>{product.Name}</h4>
                  <p>{product.Description.data.Description}</p>
                </Link>
              </LeftContainer>
            )
          })}
        </Div>
      )}
      {hoverTests && (
        <TestDiv
          onMouseEnter={openPracticeTests}
          onMouseLeave={closePracticeTests}
        >
          {navbar.Tests.map((test, index) => (
            <Link to={"/free-tests/" + test.Slug} key={index}>
              Free {test.Name} Test
            </Link>
          ))}
        </TestDiv>
      )}
    </Container>
  )
}

export default NavbarLinks
